/* eslint-disable global-require, import/no-extraneous-dependencies */

import { configureStore } from '@reduxjs/toolkit';

import orderSlice from './slices/orders';
import uiSlice from './slices/ui';
import stepSlice from './slices/steps';
import {
  api,
  v5Api,
  v5x1Api,
  v5x2Api,
  v6TravelAgentApi,
} from './slices/api';

const middleware = [
  api.middleware,
  v5Api.middleware,
  v5x1Api.middleware,
  v5x2Api.middleware,
  v6TravelAgentApi.middleware,
];

if (process.env.NODE_ENV === 'development') {
  // middleware.push(require('redux-logger').default);
}

export default configureStore({
  reducer: {
    orders: orderSlice,
    ui: uiSlice,
    steps: stepSlice,
    [api.reducerPath]: api.reducer,
    [v5Api.reducerPath]: v5Api.reducer,
    [v5x1Api.reducerPath]: v5x1Api.reducer,
    [v5x2Api.reducerPath]: v5x2Api.reducer,
    [v6TravelAgentApi.reducerPath]: v6TravelAgentApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(middleware),
  devTools: process.env.NODE_ENV !== 'production',
});
